import { Avatar, Frame, IconTheme, SpacerVertical, Typography } from '@klarna/bubble-ui';
import { hooks as i18nHooks } from 'mage-i18n';
import React from 'react';
import styled from 'styled-components';
const TRANSLATION_PREFIX = 'home-fe.boosters-plugin.instructions.plugin-doc';
const MainContainer = styled.div.withConfig({ displayName: "MainContainer", componentId: "sc-csd8sw" }) `
  display: flex;
`;
const IconContainer = styled.div.withConfig({ displayName: "IconContainer", componentId: "sc-rpa5w4" }) `
  width: 40px;
  margin-right: 20px;
`;
const TextContainer = styled.div.withConfig({ displayName: "TextContainer", componentId: "sc-1jf4kzr" }) `
  margin-right: 20px;
`;
export default function PluginDocInstructions() {
    const t = i18nHooks.useTranslator();
    return (React.createElement(Frame, { paddingToken: 'space.0' },
        React.createElement(MainContainer, null,
            React.createElement(IconContainer, null,
                React.createElement(Avatar, { icon: IconTheme, medium: true })),
            React.createElement(TextContainer, null,
                React.createElement(Typography, { textToken: 'text-style/text/paragraphs/body/bold' }, t(`${TRANSLATION_PREFIX}.title`)),
                React.createElement(SpacerVertical, { spaceToken: 'space.100' }),
                React.createElement(Typography, { textToken: 'text-style/text/paragraphs/body/regular' }, t(`${TRANSLATION_PREFIX}.content`))))));
}
